"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = Breadcrumbs;

var _react = _interopRequireDefault(require("react"));

var _Link = require("../../../utils/Link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Breadcrumbs(props) {
  var items = props.items,
      className = props.className,
      collapseOnMobile = props.collapseOnMobile,
      attributes = _objectWithoutProperties(props, ["items", "className", "collapseOnMobile"]);

  var breadcrumbs = items.map(function (item, index) {
    var href = item.href,
        to = item.to,
        reactListKey = item.reactListKey,
        children = item.children,
        itemAttributes = _objectWithoutProperties(item, ["href", "to", "reactListKey", "children"]);

    return href || to ? /*#__PURE__*/_react["default"].createElement("li", {
      key: reactListKey || index,
      className: "govuk-breadcrumbs__list-item"
    }, /*#__PURE__*/_react["default"].createElement(_Link.Link, _extends({
      href: href,
      to: to,
      className: "govuk-breadcrumbs__link"
    }, itemAttributes), children)) : /*#__PURE__*/_react["default"].createElement("li", {
      key: reactListKey || index,
      className: "govuk-breadcrumbs__list-item",
      "aria-current": "page"
    }, children);
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "govuk-breadcrumbs ".concat(className || '', " ").concat(collapseOnMobile ? 'govuk-breadcrumbs--collapse-on-mobile' : '')
  }, attributes), /*#__PURE__*/_react["default"].createElement("ol", {
    className: "govuk-breadcrumbs__list"
  }, breadcrumbs));
}